import * as React from "react";
function SvgIcChevronUp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.713 14.716l-6.669-3.85-6.669 3.85L5 14.067 12.044 10l7.044 4.067-.375.649z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcChevronUp;
